import React from 'react';
import blog1 from '../../../images/learn-JavaScript.jpg';
import blog2 from '../../../images/pdibreact.png';
import blog3 from '../../../images/and-learn-functions-400x277.jpg';
import MyBlogDetails from '../MyBlogDetails/MyBlogDetails';


const blogDetails = [
    {
        name: "Some JavaScript Interview Questions That You Should Know",
        blogImage: blog1,
        link: "https://moon663.hashnode.dev/some-interview-questions-that-you-should-know-as-a-javascript-developer"

    },
    {
        name: "More Fundamentals About JavaScript That You Should Know",
        blogImage: blog3,
        link: "https://moon663.hashnode.dev/more-fundamentals-about-javascript-that-you-should-know"
    },
    {
        name: "Some Fundamentals About React Js That You Should Know",
        blogImage: blog2,
        link: "https://moon663.hashnode.dev/some-fundamentals-about-react-js-that-you-should-know"
    }
];

const MyBlog = () => {
    return (
        <section className="my-5 pt-5">
            <div className="container">
                <div className="section-header text-center">
                    <h3 className="text-warning p-3">Some Of My Blogs</h3>
                </div>
                <div className="row">
                    {
                        blogDetails.map(blog =>
                                <div className="col mb-3">
                                    <MyBlogDetails blogs={blog}>
                                    </MyBlogDetails>
                                </div>
                        )
                    }
                </div>
            </div>

        </section>
    );
};

export default MyBlog;